import { Color } from 'chart.js'
import { IGameAnswer } from '../../data/question'
import chartValues, { TChartPallete, TPalleteType } from './chartValues'

const buildColorsArray = (
	answers: Array<IGameAnswer>,
	areAnswersHidden: boolean,
	palleteType: TPalleteType
): Array<Color> => {
	const pallete: TChartPallete = chartValues.pallete[palleteType]

	if (areAnswersHidden) {
		return [pallete.correct, pallete.incorrect, pallete.none]
	} else {
		const answerColorArrays = answers.map((answer: IGameAnswer) =>
			answer.correct ? pallete.correct : pallete.incorrect
		)
		return [...answerColorArrays, pallete.none]
	}
}

export default buildColorsArray
